import {Pipe, PipeTransform} from '@angular/core';
import {InjuryType} from "@services";

@Pipe({
    name: 'injuryType',
    standalone: true
})
export class InjuryTypePipe implements PipeTransform {
    transform(value: InjuryType | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case InjuryType.BackInjury : return "Back injury";
            case InjuryType.ChemicalExposureBurn : return "Chemical exposure / burn";
            case InjuryType.ConcussionHeadInjury : return "Concussion / Head injury";
            case InjuryType.ContusionBruise : return "Contusion / Bruise";
            case InjuryType.CumulativeTrauma : return "Cumulative trauma";
            case InjuryType.CutLaceration : return "Cut / Laceration";
            case InjuryType.ElectricShock : return "Electric Shock";
            case InjuryType.StrainSprain : return "Strain / Sprain";
            default: return value;
        }
    }
}